import { NavLink } from 'react-router'

import { useAuth } from '@langmail/shared-ui'

import { Logo } from '@/components/ui/logo'
import { useStatusLine } from '@/features/status-line/use-status-line'
import { cn } from '@/lib/utils'

const TABS = [
  { to: '/activity', label: 'Activity' },
  { to: '/access', label: 'Access' },
  { to: '/settings', label: 'Account' },
] as const

// The narrow rail: wordmark, the three tabs and the mailbox address. On phones
// it folds into a wrapping row above the content.
export function AppRail() {
  const { user, signOut } = useAuth()
  const { data: statusLine } = useStatusLine()

  if (!user) {
    return null
  }

  const address = statusLine?.mailbox.address ?? user.email
  const at = address.indexOf('@')

  return (
    <aside
      className={cn(
        'flex flex-row flex-wrap items-center gap-3 border-b bg-card px-4 py-4',
        'md:sticky md:top-0 md:h-screen md:w-[180px] md:flex-none md:flex-col md:flex-nowrap md:items-stretch md:gap-6 md:border-r md:border-b-0 md:py-5'
      )}
      data-testid="app-chrome"
    >
      <Logo className="text-xl" />
      <nav aria-label="Tabs" className="flex flex-row flex-wrap gap-1 md:flex-col">
        {TABS.map((tab) => (
          <NavLink
            className={({ isActive }) =>
              cn(
                'rounded-md px-2 py-1.5 text-sm transition-colors',
                isActive ? 'bg-accent text-foreground' : 'text-muted-foreground hover:text-foreground'
              )
            }
            key={tab.to}
            to={tab.to}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <div className="flex w-full flex-col gap-2 font-mono text-muted-foreground text-xs leading-normal [overflow-wrap:anywhere] md:mt-auto">
        {/* Break before the domain, not inside it, when the rail is narrow. */}
        <span>
          {at > 0 ? (
            <>
              {address.slice(0, at)}
              <wbr />
              {address.slice(at)}
            </>
          ) : (
            address
          )}
        </span>
        <button className="self-start text-primary hover:underline" onClick={() => signOut()} type="button">
          sign out
        </button>
      </div>
    </aside>
  )
}
